import styled from "@emotion/styled/macro";
import { Link as RouterLink } from "react-router-dom";

export const Link = styled(RouterLink)`
  color: inherit;
  text-decoration: none;
`
